module.exports = __webpack_public_path__ + "img/8.574b8f75.jpg";